import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Text } from '@blueprint/text';

import { ButtonWithLoading } from '../ButtonWithLoading';

export const TextFieldWrapper = styled('div')(({ theme: { spacing } }) => {
    return css`
        margin-bottom: ${spacing['16px']};

        label {
            overflow: hidden;
            text-overflow: ellipsis;
            right: ${spacing['16px']};
        }
    `;
});

export const CallToActionRow = styled.div(
    () => css`
        display: flex;
        justify-content: flex-start;
        width: 100%;
    `
);

export const PropertyBlock = styled.div(
    ({ theme: { spacing } }) => css`
        margin-bottom: ${spacing['16px']};
    `
);

export const StyledButtonWithIcon = styled(ButtonWithLoading)<{
    isLoading: boolean;
}>(
    ({ isLoading }) => css`
        ${isLoading &&
        `
            svg {
                margin-top: -14px;
                margin-bottom: -14px;
            }
        `}
    `
);

export const PostcodeHint = styled(Text)(
    ({ theme: { fontSizes, colors } }) => css`
        font-size: ${fontSizes['1']};
        color: ${colors['grey-steel']};
    `
);

export const SupportingCaption = styled(Text)(
    ({ theme: { fontWeight } }) => css`
        font-weight: ${fontWeight['bold']};
    `
);
